export const tituloRes = 'Búsqueda por palabras clave'